import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        setTimeout(() => {
            html.classList.add('has-popup-deluxe-open');
        }, 3000)

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.close();
            }
        });
    }


    close() {
        html.classList.remove('has-popup-deluxe-open');
    }

    destroy() {
        super.destroy()
    }
}
